import { ApiError } from '@/components/Functional/lib/request'

export function resolveEmailError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 400) return 'メールアドレスが正しくありません。'
    if (error.status === 409) return 'このメールアドレスはすでに登録されています。'
    if (error.status === 422) return '認証コードが正しくありません。'
    if (error.status === 429) return '送信回数の上限に達しました。しばらく待ってから再試行してください。'
    if (error.status === 401) return 'セッションが切れました。再度ログインしてください。'
    return 'エラーが発生しました。しばらく待ってから再試行してください。'
  }
  if (error instanceof Error) return error.message
  return 'エラーが発生しました。'
}
